import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { scrollTo } from '../utils/scrollTo';
import SafeIcon from '../common/SafeIcon';

const ExteriorSection = () => {
  const { t } = useLanguage();

  const openGallery = (e) => {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent('openGallery', { detail: { index: 0 } }));
  };

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="cursor-pointer group relative rounded-2xl overflow-hidden shadow-lg order-1"
            onClick={openGallery}
          >
            <img 
              src="https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/1fd58949d881f87b59a9b4d87afb58a3.png" 
              alt={t.gallery.alts[0]} 
              loading="lazy"
              className="w-full aspect-[4/3] object-cover transition-transform duration-500 group-hover:scale-105" 
            />
            <div className="absolute inset-0 bg-slate-900/0 group-hover:bg-slate-900/10 transition-colors duration-300 flex items-center justify-center">
              <SafeIcon name="Maximize2" className="text-white opacity-0 group-hover:opacity-100 w-8 h-8 transition-opacity duration-300 drop-shadow-md" />
            </div>
          </motion.div>
          
          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="order-2"
          >
            <div className="text-sm font-semibold tracking-wider text-slate-500 uppercase mb-3">
              {t.exterior.label}
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6 leading-tight">
              {t.exterior.title}
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-8">
              {t.exterior.desc}
            </p>
            
            <div className="grid sm:grid-cols-2 gap-4 mb-10">
              {t.exterior.badges.map((badge, idx) => (
                <div key={idx} className="flex items-start">
                  <SafeIcon name="CheckCircle" className="w-6 h-6 text-emerald-600 mr-3 shrink-0" />
                  <span className="text-slate-700 font-medium">{badge}</span>
                </div>
              ))}
            </div>
            
            <div>
              <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('contact'); }} className="btn-primary inline-flex items-center">
                <SafeIcon name="Calendar" className="w-5 h-5 mr-2" />
                {t.exterior.btn}
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ExteriorSection;